export default __webpack_public_path__ + "static/logo-d911596be5f89d37dfe21a072d94dbd6.png";